import PublicAPI from "./api";

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
};

export const cartAPI = {
    list: async () => {
        try {
            const data = await PublicAPI.get(`/cart`, getHeaders());
            return data || []; 
        } catch (error) {
            if (error.response && error.response.status === 401) {
                if (localStorage.getItem('token')) {
                    localStorage.removeItem('token');
                }
            }
            return []; // Retorna array vazio em caso de erro
        }
    },
    add: async (cartData) => {
        return await PublicAPI.post(`/cart/add`, cartData, getHeaders());
    },
    remove: async (id) => {
        return await PublicAPI.delete(`/cart/${id}`, getHeaders());
    },
    // --- ADICIONE ESTA FUNÇÃO ABAIXO ---
    update: async (id, updateData) => {
        // updateData será algo como { quantity: 5 }
        return await PublicAPI.put(`/cart/${id}`, updateData, getHeaders());
    }
};

// NOTE: Backend validation recommendation
// It's important to validate stock on the server side before accepting cart add/update requests.
// Example server-side flow (pseudo):
// 1. Receive product_id and desired quantity.
// 2. Fetch current `stock_quantity` from DB.
// 3. If `stock_quantity < desired`, return 400 with message 'Out of stock'.
// 4. Otherwise, reserve/append to cart and deduct/lock stock accordingly.

// If you want a front-end helper, you can add a checkStock function that fetches product details
// and validates `stock_quantity` prior to calling cartAPI.add.